<template>
  <div class="modal fade" id="AgreementConfirmedModal" tabindex="-1" aria-labelledby="AgreementConfirmedModalLabel" @keydown.esc="clearForm(false)">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="clientModalLabel">Список получатели</h5>
          <button type="button" @click="clearForm(false)" class="btn-close"></button>
        </div>
        <div class="modal-body p-5">
          <template v-if="this.users !== null">
            <div class="row" v-if="users && selected && !isSelected">
              <div class="col-6">
                <div class="fs-5 mb-3 text-gray-500">Список пользователи</div>
                <div class="accordion" id="kt_accordion_1">
                  <div class="accordion-item" v-for="(role, key) in users">
                    <h2 class="accordion-header" :id="'kt_accordion_1_header_'+key">
                      <button class="accordion-button fs-6 fw-semibold p-3" :class="key !== 0 ? 'collapsed' : ''" type="button" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_1_body_'+key" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                        {{ this.roles[key] }}
                      </button>
                    </h2>
                    <div :id="'kt_accordion_1_body_'+key" class="accordion-collapse collapse" :class="key === 0 ? 'show' : ''" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body p-2 scroll h-400px">
                        <div
                            v-if="users[key].length > 1"
                            class="btn btn-xs btn-light-primary d-block mb-2"
                            @click="addAllGroup(key)"
                        >
                          Добавить всех
                        </div>
                        <div
                            class="cursor-pointer custom-select-group__group_item ms-1 text-hover-primary user-select-none text-gray-600"
                            v-for="(user, userKey) in role.sort((a, b) => a.title.localeCompare(b.title))"
                            @click="addUserToArray(key, userKey)"
                        >
                          {{ user.title }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="fs-5 mb-3 text-gray-500">Список получатели</div>
                <section class="scroll h-400px custom-select-group ps-3 pt-3 pb-3 border rounded mb-3">
                  <div
                      class="cursor-pointer custom-select-group__group_item text-hover-danger cursor-pointer user-select-none text-gray-600"
                      v-if="selected.length" v-for="(item, key) in selected.sort((a, b) => a.title.localeCompare(b.title))"
                      @click="deletedItemInSelected(key)"
                  >
                    ({{this.roles[item.role]}}) {{ item.title }}
                  </div>
                </section>
                <div @click="deletedAllInSelected" class="btn-light-warning btn btn-xs d-block">Очистить</div>
              </div>
            </div>
            <template v-else>
              <div class="table-responsive scroll h-400px">
                <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 text-gray-800 mb-0" style="white-space: nowrap!important;">
                  <thead>
                  <tr class="fw-bold fs-8 text-gray-400">
                    <th class="w-50px">ID</th>
                    <th class="w-50px">Роль</th>
                    <th class="w-50px text-center">Статус</th>
                    <th>Ф.И.О</th>
                  </tr>
                  </thead>
                  <tbody v-if="selected.length >= 0">
                  <tr v-for="(item, key) in selected.sort((a, b) => a.title.localeCompare(b.title))" :key="key" class="align-middle">
                    <td>{{ item.id }}</td>
                    <td>{{ this.roles[item.role] }}</td>
                    <td class="text-center">
                      <i v-if="item.status === 0" class="ki-outline ki-time fs-4 text-warning" title="Отправлено"></i>
                      <i v-if="item.status === 2" class="ki-outline ki-check-circle fs-4 text-primary" title="Согласовано"></i>
                      <i v-if="item.status === 1" class="ki-outline ki-cross-circle fs-4 text-danger" title="Не согласовано"></i>
                    </td>
                    <td>{{ item.title }}</td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="selected.length <= 0" class="p-10 text-center text-gray-600">
                  Нет записи
                </div>
              </div>
            </template>
          </template>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button @click="clearForm(false)" class="btn btn-sm btn-light-warning" type="button">Закрыть</button>
          <button v-if="!isSelected" @click="setAgreementUsers" class="btn btn-sm btn-primary" type="button">Добавить</button>
          <button v-else @click="exportAgreement(agreementId)" class="btn btn-sm btn-primary" type="button">Экспорт</button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFull from '@/components/Main/LoaderFull'
import axios from "axios";
export default {
  name: 'AgreementConfirmedModal',
  components: {LoaderFull},
  props: {
    agreementId: {
      type: Number,
      required: true
    },
    usersList: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loader: false,
      users:  null,
      selected: [],
      isSelected: false,
      roles: {
        0: 'Администратор',
        1: 'Модератор',
        2: 'Бухгалтер',
        3: 'Менеджер',
        4: 'Агент',
        5: 'Суб-Агент',
        6: 'ДРМ ПОДФТ',
        7: 'Сервис менеджер',
        8: 'Резерв',
      },
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('AgreementConfirmedModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.clearForm(false)
      });
    }, 10)
    this.getConfirmeds(this.agreementId)
  },
  methods: {
    clearForm(isUpdateList) {
      this.users = null
      this.selected = []
      this.$emit('close', {update: isUpdateList})
    },
    addUserToArray(role, key) {
      this.selected.push(this.users[role][key])
      delete this.users[role].splice(key, 1)
    },
    addAllGroup(key) {
      this.users[key].forEach(item => {
        this.selected.push(item)
      })
      this.users[key] = []
    },
    deletedItemInSelected(key) {
      this.users[this.selected[key].role].push(this.selected[key])
      this.selected.splice(key, 1)
    },
    deletedAllInSelected() {
      this.selected.forEach(item => { this.users[item.role].push(item) })
      this.selected = []
    },
    setAgreementUsers() {
      this.loader = true
      const headers = {id: this.agreementId, users: this.selected}
      axios.post('/api/admin/agreement/admin/set-users', headers)
          .then(res => {
            if (res.data.result) {
              this.clearForm(true)
            }
          })
          .catch(err => {console.log(err)})
          .finally(() => this.loader = false)
    },
    getConfirmeds(id) {
      this.loader = true
      axios.get('/api/admin/agreement/admin/confirmeds/'+id)
          .then(res => {
            if (res.data) {
              this.selected = res.data
              this.isSelected = !!res.data.length
            }
          })
          .catch(err => {console.log(err.message)})
          .finally(() => {this.loader = false})
    },
    exportAgreement(id) {
      this.loader = true
      axios.get('/api/admin/agreement/admin/export', {responseType: 'blob', params: {id:id}})
          .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'agreement.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(err => {})
          .finally(() => {this.loader = false})
    }
  },
  watch: {
    usersList: {
      immediate: true,
      handler(val) {
        if (val) this.users = structuredClone(val)
      }
    }
  }
}
</script>

<style scoped>

</style>